<template>
  <SubTitle :TitleName="'おしらせ'" />
  <v-card class="mx-auto w-75 mb-10" max-width="1280" variant="Tonal">
    <v-list :items="items" item-props lines="three">
      <template v-slot:subtitle="{ subtitle }">
        <div v-html="subtitle" class="subtitle_text"></div>
      </template>
    </v-list>
  </v-card>
</template>

<script>
  import SubTitle from "./SubTitle.vue";

  export default {
    data: () => ({
      items: [
        {
          title: "2026/1/5",
          subtitle: `実況配信ガイドラインを追加いたしました。`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
        {
          title: "2024/12/17",
          subtitle: `実況配信ガイドラインを追加いたしました。`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
        {
          title: "2024/11/26",
          subtitle: `初回特典、店舗特典の情報、スクリーンショットを更新しました。`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
        {
          title: "2024/9/13",
          subtitle: `発売日が2024年12月19日に決定しました。`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
        {
          title: "2024/8/8",
          subtitle: `公式サイトをオープンいたしました。`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
      ],
    }),
    components: {
      SubTitle,
    },
  };
</script>

<style scoped>
  .subtitle_text {
    font-size: 1.2em;
    line-height: 2em;
  }
</style>
